import { version } from '../../package.json';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApplicationService } from './providers/services/application.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public version: string = version;
  title = 'Converge';
  loader: boolean = false;

  constructor(private application: ApplicationService) {
    if (this.application.currentUser) {
      this.application.getBusinessUnit().subscribe(response => {
        if (response.success) {
          this.application.businessUnit = response.data;
          localStorage.setItem('businessUnit', response.data);
        }
      });
    }
  }

  ngOnInit() {
    if (environment.production) {
      if (window) {
        window.console.log = function () { }
        window.console.warn = function () { }
        window.console.error = function () { }
      }
    }

    this.application.showLoader.asObservable().subscribe(res => {
      this.loader = res
    });
  }

}
